import { WorkspaceMembersService, WorkspacePermissionService, WorkspaceTeamService } from "@affine/core/modules/permissions";
import type { TeamNode } from "@affine/core/modules/permissions/entities/teams";
import { ArrowDownSmallIcon, MoreHorizontalIcon, PlusIcon } from "@blocksuite/icons/rc";
import { useLiveData, useService } from "@toeverything/infra";
import clsx from "clsx";
import { NodeApi, Tree, TreeApi, type NodeRendererProps } from 'react-arborist'
import * as styles from './styles.css';
import { WorkspaceService } from "@affine/core/modules/workspace";
import { IconButton, Menu, MenuItem, useConfirmModal, usePromptModal } from "@affine/component";
import { useMenuItem } from "../../../../../../../component/src/ui/menu/use-menu-item";
import { useCallback, useEffect, useRef } from "react";

export const TeamTree = () => {
  const { openPromptModal } = usePromptModal()
  const { openConfirmModal } = useConfirmModal();
  const { } = useMenuItem({

  })
  const teamService = useService(WorkspaceTeamService);
  const workspaceService = useService(WorkspaceService);
  const membersService = useService(WorkspaceMembersService);
  const permissionService = useService(WorkspacePermissionService);
  
  const teamTree = useLiveData(teamService.teams.teams$);
  const isLoading = useLiveData(teamService.teams.isLoading$);
  const curTeam = useLiveData(membersService.members.team$);
  const treeRef = useRef<TreeApi<TeamNode>>(null);

  const isOwner = useLiveData(permissionService.permission.isOwner$);
  const isAdmin = useLiveData(permissionService.permission.isAdmin$);
  const isOwnerOrAdmin = isOwner || isAdmin;

  useEffect(() => {
    if (treeRef.current) {
      console.info(treeRef.current.selectedNodes, 'selectedNodes', curTeam)
      if (treeRef.current.selectedNodes.length < 1) {
        if (curTeam) {
          treeRef.current.select(curTeam.id)
        } else {
          teamTree && treeRef.current.select(teamTree[0].id)
        }
      }
    }
  }, [treeRef, curTeam, teamTree])

  const workspaceName = useLiveData(workspaceService.workspace.name$)

  const Node = ({ node, style }: NodeRendererProps<TeamNode>) => {

    return <div
      style={style}
      className={clsx(styles.node, node.state)}
      onClick={() => node.select()}
    >
      {!node.isLeaf && <IconButton icon={<ArrowDownSmallIcon style={{
        transform: !node.isOpen ? 'rotate(-90deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s ease-in-out',
        marginRight: '4px',
      }} onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        node.toggle()
      }} />}>
      </IconButton>}
      <div style={{
        flexGrow: 1,
        // max 1 line
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '14px',
        fontWeight: 400,
      }}>
        {node.level === 0 ? workspaceName : node.data.name}
      </div>
      {
        isOwnerOrAdmin &&  <div className={styles.nodeAction}>
          <IconButton icon={<PlusIcon />} onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            handleAdd(node.data)
          }} />
          {
            node.level !== 0 && <Menu

              items={
                <>
                  <MenuItem onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    handleEdit(node.data)
                  }}>
                    重命名
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handleDelete(node.data)
                    }}
                  >
                    删除小组
                  </MenuItem>
                </>
              }
            >
              <IconButton icon={<MoreHorizontalIcon />} />
            </Menu>
          }
        </div>
      }
    </div>
  }

  const handleSelect = (nodes: NodeApi<TeamNode>[]) => {
    console.info(nodes)
    if (nodes.length > 0) {
      const node = nodes[0]
      if (node.level === 0) {
        membersService.members.setTeamId(undefined)
        membersService.members.revalidate()
        return
      }
      membersService.members.setTeamId(node.data)
      membersService.members.revalidate()
    }
  }

  const handleDelete = useCallback((node: TeamNode) => {
    openConfirmModal({
      title: '删除小组',
      description: `确定要删除小组 ${node.name} 吗？`,
      confirmText: '删除',
      cancelText: '取消',
      onConfirm() {
        teamService.deleteTeam(node.id).then(() => {
          teamService.teams.revalidate();
        })
      },
      onCancel() {

      },
    })
  }, [openConfirmModal])

  const handleEdit = useCallback((node: TeamNode) => {
    openPromptModal({
      label: '请输入小组名称',
      confirmText: '确定',
      cancelText: '取消',
      defaultValue: node.name,
      onConfirm(text) {
        teamService.updateTeam(node.id, text).then(() => {
          teamService.teams.revalidate();
        })
      },
      onCancel() {

      },
    })
  }, [openPromptModal])

  const handleAdd = (node: TeamNode) => {
    openPromptModal({
      label: '请输入小组名称',
      confirmText: '确定',
      cancelText: '取消',
      onConfirm(text) {
        teamService.createTeam(text, node.id).then(() => {
          teamService.teams.revalidate();
        })
      },
      onCancel() {

      },
    })
  }

  return <div>
    {isLoading ? (
      <div>Loading...</div>
    ) : (
      teamTree && <Tree
        width={230}
        height={600}
        selection="single"
        ref={treeRef}
        rowHeight={30}
        className={styles.tree}
        data={teamTree}
        onSelect={handleSelect}
        indent={10}
      >{Node}</Tree>
    )}
  </div>;
}